import { useState } from 'react';
import cn from 'classnames';
import { Badge, BottomSheet, Box, Callout, Column, FullRow, Row, Switch, Typography } from 'seagull';
import { Bulb24, WideArrowForward } from 'seagull/icons';
import { Intent } from "../../../../../../../infra/access-control";
import styles from "./ServiceItem.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const MobileServiceItem = _ref => {
  var _service$bundle;
  let {
    service,
    isOptional,
    isSelected,
    onToggle,
    isDisabled,
    discountBadgeData,
    getBillingBadgeText,
    futureBillingText,
    renderPrice,
    getSubtitlePrice,
    hasIncludedServices,
    getServiceDescription,
    ServiceItemTestIds
  } = _ref;
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const openBottomSheet = () => setIsBottomSheetOpen(true);
  const closeBottomSheet = () => setIsBottomSheetOpen(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Column, {
      className: cn(styles.serviceItem, {
        [styles.disabled]: isDisabled
      }),
      testId: ServiceItemTestIds.Root(),
      children: /*#__PURE__*/_jsx(Column, {
        className: styles.card,
        onClick: openBottomSheet,
        role: "button",
        tabIndex: 0,
        children: /*#__PURE__*/_jsxs(Column, {
          gap: 8,
          children: [/*#__PURE__*/_jsxs(FullRow, {
            gap: 12,
            alignItems: "center",
            children: [isOptional && /*#__PURE__*/_jsx(Box, {
              onClick: e => e.stopPropagation(),
              children: /*#__PURE__*/_jsx(Switch, {
                intent: Intent.SelectOptionalService,
                checked: isSelected,
                testId: ServiceItemTestIds.OptionalToggle(),
                onChange: onToggle
              })
            }), /*#__PURE__*/_jsx(Typography, {
              className: styles.serviceName,
              skin: isDisabled ? 'secondary' : 'standard',
              ellipsis: true,
              testId: ServiceItemTestIds.Name(),
              children: service.name
            }), /*#__PURE__*/_jsx(Box, {
              className: styles.mobileChevron,
              testId: ServiceItemTestIds.MobileChevron(),
              children: /*#__PURE__*/_jsx(WideArrowForward, {})
            })]
          }), hasIncludedServices && /*#__PURE__*/_jsxs(Column, {
            gap: 4,
            testId: ServiceItemTestIds.IncludedServices(),
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "paragraph2",
              weight: "normal",
              children: "Included services:"
            }), /*#__PURE__*/_jsx("ul", {
              className: styles.includedServicesList,
              children: (_service$bundle = service.bundle) === null || _service$bundle === void 0 ? void 0 : _service$bundle.services.map(includedService => /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "paragraph2",
                  skin: "secondary",
                  weight: "light",
                  children: includedService.name
                })
              }, includedService.serviceTemplateId))
            })]
          }), /*#__PURE__*/_jsx(Box, {
            testId: ServiceItemTestIds.Price(),
            children: renderPrice()
          }), /*#__PURE__*/_jsxs(Row, {
            gap: 8,
            children: [discountBadgeData && /*#__PURE__*/_jsx(Badge, {
              rounded: true,
              outlined: true,
              skin: "primary",
              className: styles.billingBadge,
              testId: ServiceItemTestIds.DiscountBadge(),
              children: discountBadgeData.text
            }), /*#__PURE__*/_jsx(Badge, {
              rounded: true,
              outlined: true,
              skin: "primary",
              className: styles.billingBadge,
              testId: ServiceItemTestIds.BillingBadge(),
              children: getBillingBadgeText()
            })]
          }), futureBillingText && /*#__PURE__*/_jsx(Callout, {
            variant: "paragraph2",
            intent: "info",
            icon: /*#__PURE__*/_jsx(Bulb24, {
              width: 24,
              height: 24
            }),
            classes: {
              main: styles.futureBillingCallout
            },
            testId: ServiceItemTestIds.FutureBillingCallout(),
            children: futureBillingText
          })]
        })
      })
    }), /*#__PURE__*/_jsx(BottomSheet, {
      open: isBottomSheetOpen,
      onClose: closeBottomSheet,
      children: /*#__PURE__*/_jsxs(Column, {
        gap: 16,
        className: styles.bottomSheetContent,
        children: [/*#__PURE__*/_jsxs(Column, {
          gap: 2,
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            weight: "normal",
            children: service.name
          }), /*#__PURE__*/_jsxs(Typography, {
            variant: "paragraph2",
            skin: "secondary",
            children: [getSubtitlePrice(), " \u2022 ", getBillingBadgeText()]
          })]
        }), getServiceDescription({
          forMobile: true,
          hideIncludedServices: true
        })]
      })
    })]
  });
};